/**
 * Les lectures de « Gérer une séance », celles de l'ancien écran au montage (`ManageRDVScreen`) : le
 * décompte des absences du mois (`getSubstitutionAbsenceSummary`, pour tous) et ce que l'absence
 * changerait à chaque élève (`getTutorAbsenceImpact`, sauf un individuel, qui ne se signale pas).
 *
 * Patron B : aucune des deux réponses n'a de réducteur ; elles restent ici.
 */
import { liveService } from "../../../../../../data/services/liveService"
import {
    type ApiAbsenceImpactStudent,
    type ApiAbsenceSummary,
} from "../../../../adapters/tutor/Lives/tutorManageSessionAdapter"
import { useApiFetch } from "../../../hooks/useApiFetch"

export function useTutorManageSessionData(liveId: string | number | null, isIndividual: boolean) {
    const summary = useApiFetch<ApiAbsenceSummary>({
        service: liveService.getSubstitutionAbsenceSummary,
        requestKey: "summary",
        idleOnError: true,
    })
    const impact = useApiFetch<{ students?: ApiAbsenceImpactStudent[] | null }>({
        service: liveService.getTutorAbsenceImpact,
        routeParams: { id: liveId },
        requestKey: liveId != null ? String(liveId) : null,
        enabled: liveId != null && !isIndividual,
        idleOnError: true,
    })
    return {
        summary: summary.raw,
        /** Le décompte est lu (ou n'a pas pu l'être) : l'étape de l'absence peut s'ouvrir. */
        summaryRead: !summary.loading,
        impactStudents: impact.raw?.students ?? null,
    }
}
